import React from "react";
import useTranslation from "../i18n/useTranslation";

const NotFound = () => {
   const { t } = useTranslation();

   return (
      <div>
         <h2>{t("auth.notFoundTitle")}</h2>
         <p>{t("auth.notFoundMessage")}</p>
      </div>
   );
};

export default NotFound;
